import Vue from 'vue'
const constants = require('@/util/constants')
// import * as constants from '@/util/constants'

/**
 * 登录状态
 */
export const connected = state => {
  return !!localStorage.access_token || state.passport.token.access_token.length > 0 || Vue.ls.get(constants.ACCESS_TOKEN)
}

/**
 * access_token
 * @param {*} state state
 */
export const accessToken = state => {
  return state.passport.token.access_token
}

/**
 * 用户信息
 * @param {*} state state
 */
export const userInfo = state => {
  return state.user.info
}

export const autoReplyList = state => {
  return state.user.autoReplyList
}

/**
 * 当前访客个人信息
 * @param {*} state 
 * @returns 
 */
export const currentVisitorInfo = state => {
  return state.user.current_visitor_info
}

/**
 * 是否管理员
 * @param {*} state state
 */
export const isAdmin = state => {
  return state.user.is_admin
}

/**
 * 在线状态
 */
export const status = state => {
  // return state.user.settings.accept_status
  return state.user.info.acceptStatus
}

// 视频客服在线状态
export const webrtcStatus = state => {
  return state.user.info.webrtcStatus
}

export const userTopThreads = state => {
  // let threads = state.user.top_threads.filter(thread => {
  //   return true
  // })
  let threads = []
  for (let i = 0; i < state.user.top_threads.length; i++) {
    const thread = state.user.top_threads[i]
    let contains = threads.some((trd) => {
      return trd.topic === thread.topic;
    });
    if (!contains) {
      threads.push(thread)
    }
  }
  return threads.sort(function (a, b) {
    if (a.timestamp < b.timestamp) {
      return 1
    }
    if (a.timestamp > b.timestamp) {
      return -1
    }
    return 0
  })
}

export const userStarThreads = state => {
  // let threads = state.user.star_threads.filter(thread => {
  //   return true
  // })
  let threads = []
  for (let i = 0; i < state.user.star_threads.length; i++) {
    const thread = state.user.star_threads[i]
    let contains = threads.some((trd) => {
      return trd.topic === thread.topic;
    });
    if (!contains) {
      threads.push(thread)
    }
  }
  return threads.sort(function (a, b) {
    if (a.starType > b.starType) {
      return 1
    }
    if (a.starType < b.starType) {
      return -1
    }
    return 0
  })
}

/**
 * 用户所有会话thread
 * @param {*} state state
 */
export const userThreads = state => {
  let threads = state.user.threads.filter(thread => {
    return true
  })
  return threads.sort(function (a, b) {
    if (a.timestamp < b.timestamp) {
      return 1
    }
    if (a.timestamp > b.timestamp) {
      return -1
    }
    return 0
  })
}

/**
 * 客服会话thread
 * @param {*} state state
 */
export const agentThreads = state => {
  let threads = state.user.agent_threads.filter(thread => {
    return true
  })
  return threads.sort(function (a, b) {
    if (a.timestamp < b.timestamp) {
      return 1
    }
    if (a.timestamp > b.timestamp) {
      return -1
    }
    return 0
  })
}

/**
 * 同事会话thread
 * @param {*} state state
 */
export const contactThreads = state => {
  let threads = state.user.contact_threads.filter(thread => {
    return true
  })
  return threads.sort(function (a, b) {
    if (a.timestamp < b.timestamp) {
      return 1
    }
    if (a.timestamp > b.timestamp) {
      return -1
    }
    return 0
  })
}

/**
 * 群组会话thread
 * @param {*} state state
 */
export const groupThreads = state => {
  let threads = state.user.group_threads.filter(thread => {
    return true
  })
  return threads.sort(function (a, b) {
    if (a.timestamp < b.timestamp) {
      return 1
    }
    if (a.timestamp > b.timestamp) {
      return -1
    }
    return 0
  })
}

/**
 * 渠道会话thread
 * @param {*} state state
 */
export const channelThreads = state => {
  let threads = state.user.channel_threads.filter(thread => {
    return true
  })
  return threads.sort(function (a, b) {
    if (a.timestamp < b.timestamp) {
      return 1
    }
    if (a.timestamp > b.timestamp) {
      return -1
    }
    return 0
  })
}

/**
 * 工单会话thread
 * @param {*} state state
 */
export const ticketThreads = state => {
  let threads = state.user.ticket_threads.filter(thread => {
    return true
  })
  return threads.sort(function (a, b) {
    if (a.timestamp < b.timestamp) {
      return 1
    }
    if (a.timestamp > b.timestamp) {
      return -1
    }
    return 0
  })
}

/**
 * 意见反馈会话thread
 * @param {*} state state
 */
export const feedbackThreads = state => {
  let threads = state.user.feedback_threads.filter(thread => {
    return true
  })
  return threads.sort(function (a, b) {
    if (a.timestamp < b.timestamp) {
      return 1
    }
    if (a.timestamp > b.timestamp) {
      return -1
    }
    return 0
  })
}

export const totalUnreadCount = state => {
  // let threads = state.user.threads.filter(thread => {
  //   return true
  // })
  let count = 0
  for (let i = 0; i < state.user.threads.length; i++) {
    const element = state.user.threads[i]
    count += element.unreadCount
  }
  return count
}

/**
 * 用户进行中会话thread
 * @param {*} state state
 */
export const userChattingThreads = state => {
  return state.user.threads.filter(thread => {
    return !thread.closed
  })
}

// 当前会话输入框草稿
export const userCurrentThreadDraft = state => {
  for (let i = 0; i < state.user.drafts.length; i++) {
    const element = state.user.drafts[i]
    if (element.key === state.user.current_thread.topic) {
      return element.value
    }
  }
  return ''
}

// 所有输入框草稿draft
export const userDrafts = state => {
  return state.user.drafts
}

export const userSelfEmojis = state => {
  return state.user.selfEmojis
}

export const userSelfImages = state => {
  return state.user.selfImages
}

export const userSelfFiles = state => {
  return state.user.selfFiles
}

/**
 * 用户结束了的会话thread
 * @param {*} state state
 */
export const userClosedThreads = state => {
  return state.user.threads.filter(thread => {
    return thread.closed
  })
}

export const userCurrentChatType = state => {
  return state.user.current_chat_type
}

/**
 * 当前会话thread
 * @param {*} state state
 */
export const userCurrentThread = state => {
  return state.user.current_thread
}

export const userCurrentThreadMore = state => {
  return state.user.current_thread_more
}

export const userCurrentCustomer = state => {
  return state.user.current_crm
}

export const userCrms = state => {
  return state.user.crms
}

export const userCustomers = state => {
  return state.user.customers
}

export const userCurrentTicket = state => {
  return state.user.current_ticket
}

export const userCurrentOnlineUser = state => {
  return state.user.current_online_user
}

export const userCurrentMonitorThread = state => {
  return state.user.current_monitor_thread
}

export const userCurrentTicketThread = state => {
  return state.user.current_ticket.thread
}

export const disabled = state => {
  return state.user.current_thread.tid === ''
}

export const monitorDisabled = state => {
  return state.user.current_monitor_thread.tid === ''
}

export const ticketDisabled = state => {
  return state.user.current_ticket.thread.tid === '' || state.user.current_ticket.closed
}

/**
 * 当前排队队列
 * @param {*} state state
 */
export const userQueues = state => {
  return state.user.queues
}

export const userQueuesCount = state => {
  return state.user.queues.content.length
}

export const userCurrentQueue = state => {
  return state.user.current_queue
}

/**
 * 当前联系人
 */
export const userCurrentContact = state => {
  return state.user.current_contact
}

/**
 * 当前群组
 */
export const userCurrentGroup = state => {
  return state.user.current_group
}

export const userBrowses = state => {
  return state.user.browses
}

export const userCurrentBrowse = state => {
  return state.user.current_browse
}

export const userNotices = state => {
  return state.user.notices
}

export const userCurrentNotice = state => {
  return state.user.current_notice
}

export const userTodos = state => {
  return state.user.todos
}

export const userCurrentTodo = state => {
  return state.user.current_todo
}

export const userNoticeBrowses = state => {
  return state.user.notice_browses
}

export const userCurrentNoticeBrowse = state => {
  return state.user.current_notice_browse
}

export const userContacts = state => {
  return state.user.contacts
}

export const userGroups = state => {
  return state.user.groups
}

export const userTickets = state => {
  return state.user.tickets
}

export const totalTicketUnreadCount = state => {
  let count = 0
  for (let i = 0; i < state.user.formereply_tickets.content.length; i++) {
    const ticket = state.user.formereply_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  for (let i = 0; i < state.user.tobereplied_tickets.content.length; i++) {
    const ticket = state.user.tobereplied_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  for (let i = 0; i < state.user.done_tickets.content.length; i++) {
    const ticket = state.user.done_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  for (let i = 0; i < state.user.ignored_tickets.content.length; i++) {
    const ticket = state.user.ignored_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  for (let i = 0; i < state.user.closed_tickets.content.length; i++) {
    const ticket = state.user.closed_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  return count
}

export const userForMeReplyTickets = state => {
  return state.user.formereply_tickets
}

export const forMeReplyTicketsUnreadCount = state => {
  let count = 0
  for (let i = 0; i < state.user.formereply_tickets.content.length; i++) {
    const ticket = state.user.formereply_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  return count
}

export const userToBeRepliedTickets = state => {
  return state.user.tobereplied_tickets
}

export const toBeRepliedTicketsUnreadCount = state => {
  let count = 0
  for (let i = 0; i < state.user.tobereplied_tickets.content.length; i++) {
    const ticket = state.user.tobereplied_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  return count
}

export const userDoneTickets = state => {
  return state.user.done_tickets
}

export const doneTicketsUnreadCount = state => {
  let count = 0
  for (let i = 0; i < state.user.done_tickets.content.length; i++) {
    const ticket = state.user.done_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  return count
}

export const userIgnoredTickets = state => {
  return state.user.ignored_tickets
}

export const ignoreTicketsUnreadCount = state => {
  let count = 0
  for (let i = 0; i < state.user.ignored_tickets.content.length; i++) {
    const ticket = state.user.ignored_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  return count
}

export const userClosedTickets = state => {
  return state.user.closed_tickets
}

export const closedTicketsUnreadCount = state => {
  let count = 0
  for (let i = 0; i < state.user.closed_tickets.content.length; i++) {
    const ticket = state.user.closed_tickets.content[i]
    count += ticket.thread.unreadCount
  }
  return count
}

export const userBlocks = state => {
  return state.user.blocks
}

export const userCurrentBlock = state => {
  return state.user.current_block
}

export const userSummaries = state => {
  return state.user.summaries
}

export const userFeedbacks = state => {
  return state.user.feedbacks
}

export const userStatuses = state => {
  return state.user.statuses
}

export const userNodisturbThreadTopics = state => {
  return state.user.nodisturb_thread_topics
}

export const userUnreadThreadTopics = state => {
  return state.user.unread_thread_topics
}

export const userOnlineUsers = state => {
  return state.user.onlineUsers
}

export const showBottomStatistics = state => {
  return state.show_bottom_statistics
}

export const showOutOfTime = state => {
  return state.show_out_of_time
}

// 方便区分
export const showInputTipSetting = state => {
  return state.show_input_tip
}

export const isWebrtcStarted = state => {
  return state.is_webrtc_started
}

export const isWechatMpBinded = state => {
  return state.is_wechat_mp_binded
}

export const isWechatMpPushEnabled = state => {
  return state.is_wechat_mp_push_enabled
}

// 右侧当前tab
export const rightActiveTab = state => {
  return state.right_active_tab
}

/**
 * 搜索历史消息
 */
export const messagesArchive = state => {
  // let messages = state.messagesArchive
  return state.messagesArchive
}

/**
 * 当前会话聊天记录
 * @param {*} state state
 */
export const messages = state => {
  let messages = state.user.messages.filter(message => {
    if (state.user.current_thread.type === constants.THREAD_TYPE_THREAD ||
        state.user.current_thread.type === constants.THREAD_TYPE_ROBOT_TO_AGENT ||
        state.user.current_thread.type === constants.THREAD_TYPE_WORKGROUP ||
        state.user.current_thread.type === constants.THREAD_TYPE_APPOINTED) {
      // return message.thread.tid === state.user.current_thread.tid // 根据visitor.uid过滤，不能使用thread.tid
      // 过滤掉 选择问卷、选择工作组、选择公司
      return (message.thread.visitor.uid === state.user.current_thread.visitor.uid) &&
      (message.type !== constants.MESSAGE_TYPE_ROBOT) &&
      (message.type !== constants.MESSAGE_TYPE_QUESTIONNAIRE) &&
      (message.type !== constants.MESSAGE_TYPE_WORK_GROUP) &&
      (message.type !== constants.MESSAGE_TYPE_COMPANY)
    } else if (state.user.current_thread.type === constants.THREAD_TYPE_CONTACT) {
      // return message.cid === state.user.current_contact.uid || message.user.uid === state.user.current_contact.uid
      return false
    } else if (state.user.current_thread.type === constants.THREAD_TYPE_GROUP) {
      // return message.gid === state.user.current_group.wid
      return false
    }
  })
  return messages.sort(function (a, b) {
    if (a.id > b.id) {
      return 1
    }
    if (a.id < b.id) {
      return -1
    }
    return 0
  })
}

export const protobufMessages = state => {
  // 过滤相应topic的messages
  let topicMessages = state.user.protobufMessages.filter(message => {
    if (state.user.current_thread.type === constants.THREAD_TYPE_CONTACT &&
      message.thread.type === constants.THREAD_TYPE_CONTACT) {
      // 一对一
      if (message.thread.tid === state.user.current_thread.tid) {
        return true
      } else if (message.user.uid === state.user.current_thread.topic) {
        return true
      } else if (message.cid === state.user.current_thread.topic) {
        return true
      } else {
        return false
      }
    } else if (state.user.current_thread.type === constants.THREAD_TYPE_TICKET_WORKGROUP ||
      state.user.current_thread.type === constants.THREAD_TYPE_TICKET_WORKGROUP) {
      // 工单会话仅显示本工单消息
      if (message.thread.tid === state.user.current_thread.tid) {
        return true
      } else {
        return false
      }
    } else {
      // 群组/客服会话聊天记录
      return message.thread.topic === state.user.current_thread.topic
    }
  })
  // 排序
  let sortedMessages = topicMessages.sort(function (a, b) {
    if (a.createdAt > b.createdAt) {
      return 1
    }
    if (a.createdAt < b.createdAt) {
      return -1
    }
    return 0
  })
  // 去除 连续的 ‘继续会话’ 消息，只显示最后一条
  let noreentryMessages = []
  var length = sortedMessages.length
  for (var i = 0; i < length; i++) {
    var message = sortedMessages[i]
    if (message.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD_REENTRY) {
      // 连续的 ‘继续会话’ 消息，只显示最后一条
      if (i + 1 < length) {
        var nextmsg = sortedMessages[i + 1];
        if (nextmsg.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD_REENTRY) {
          continue
        } else {
          noreentryMessages.push(message)
        }
      }
    } else {
      noreentryMessages.push(message)
    }
  }
  // 去掉连续 ‘访客离线’ 消息，只显示最后一条
  let nodisconnectMessages = []
  length = noreentryMessages.length
  for (var i = 0; i < length; i++) {
    var message = noreentryMessages[i]
    if (message.type === constants.MESSAGE_TYPE_NOTIFICATION_DISCONNECT) {
      // 连续的 ‘访客离线’ 消息，只显示最后一条
      if (i + 1 < length) {
        var nextmsg = noreentryMessages[i + 1];
        if (nextmsg.type === constants.MESSAGE_TYPE_NOTIFICATION_DISCONNECT) {
          continue
        } else {
          nodisconnectMessages.push(message)
        }
      }
    } else {
      nodisconnectMessages.push(message)
    }
  }
  // 去掉连续 ‘访客上线’ 消息，只显示最后一条
  let protoMessages = []
  length = nodisconnectMessages.length
  for (var i = 0; i < length; i++) {
    var message = nodisconnectMessages[i]
    if (message.type === constants.MESSAGE_TYPE_NOTIFICATION_CONNECT) {
      // 连续的 ‘访客上线’ 消息，只显示最后一条
      if (i + 1 < length) {
        var nextmsg = nodisconnectMessages[i + 1];
        if (nextmsg.type === constants.MESSAGE_TYPE_NOTIFICATION_CONNECT) {
          continue
        } else {
          protoMessages.push(message)
        }
      }
    } else {
      protoMessages.push(message)
    }
  }
  return protoMessages
}

// 商品消息
export const commodityMessages = state => {
  return state.user.commodityMessages
}

export const blockMessages = state => {
  let messages = state.user.protobufMessages.filter(message => {
      // 客服会话聊天记录
      let uid = message.thread.topic.split('/')[1]
      return uid === state.user.current_block.blockedUser.uid
  })
  return messages.sort(function (a, b) {
    if (a.createdAt > b.createdAt) {
      return 1
    }
    if (a.createdAt < b.createdAt) {
      return -1
    }
    return 0
  })
}

export const monitorMessages = state => {
  let messages = state.user.protobufMessages.filter(message => {
    if (state.user.current_monitor_thread.type === constants.THREAD_TYPE_CONTACT && message.thread.type === constants.THREAD_TYPE_CONTACT) {
      // 一对一
      if (message.thread.tid === state.user.current_monitor_thread.tid) {
        return true
      } else if (message.user.uid === state.user.current_monitor_thread.topic) {
        return true
      } else if (message.cid === state.user.current_monitor_thread.topic) {
        return true
      } else {
        return false
      }
    } else {
      // 群组/客服会话聊天记录
      return message.thread.topic === state.user.current_monitor_thread.topic
    }
  })
  return messages.sort(function (a, b) {
    if (a.createdAt > b.createdAt) {
      return 1
    }
    if (a.createdAt < b.createdAt) {
      return -1
    }
    return 0
  })
}

export const ticketMessages = state => {
  //
  let messages = state.user.protobufMessages.filter(message => {
    return message.thread.topic === state.user.current_ticket.thread.topic
  })
  return messages.sort(function (a, b) {
    if (a.createdAt > b.createdAt) {
      return 1
    }
    if (a.createdAt < b.createdAt) {
      return -1
    }
    return 0
  })
}

export const statistic = state => {
  return state.statistic
}

export const statisticsAgentToday = state => {
  return state.statistics_agent_today
}

export const statisticsAgentTodayUids = state => {
  return state.statistics_agent_today_uids
}

export const statisticThreads = state => {
  return state.statistic.threads
}

export const statisticRates = state => {
  return state.statistic.rates
}

export const totalThreadCounts = state => {
  let totalThreadCounts = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ]
  for (let i = 0; i < state.statistic.statistic_list.length; i++) {
    const element = state.statistic.statistic_list[i]
    totalThreadCounts[element.hour] = element.currentThreadCount
  }
  return totalThreadCounts
}

export const totalQueueCounts = state => {
  let totalQueueCounts = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ]
  for (let i = 0; i < state.statistic.statistic_list.length; i++) {
    const element = state.statistic.statistic_list[i]
    totalQueueCounts[element.hour] = element.queuingCount
  }
  return totalQueueCounts
}

export const historyThreads = state => {
  return state.histories
}

export const historyRecordsThreads = state => {
  // return state.history_records
  // 排序
  let historyRecords = []
  for (let i = 0; i < state.history_records.content.length; i++) {
    const element = state.history_records.content[i]
    historyRecords.push(element)
  }
  let sortedRecords = historyRecords.sort(function (a, b) {
    if (a.timestamp > b.timestamp) {
      return -1
    }
    if (a.timestamp < b.timestamp) {
      return 1
    }
    return 0
  })
  historyRecords.content = sortedRecords
  return historyRecords
}

export const rates = state => {
  return state.rates
}

export const historyMessages = state => {
  return state.messages
}

export const leaveMessages = state => {
  return state.leaveMessages
}

export const statuses = state => {
  return state.statuses
}

export const queues = state => {
  return state.queues
}

export const browses = state => {
  return state.browses
}

export const userMonitorThreads = state => {
  return state.user.monitor_threads
}

export const qualities = state => {
  return state.qualities
}

export const agents = state => {
  return state.agents
}

export const onlineAgents = state => {
  return state.online_agents
}

export const robotThreadsOngoing = state => {
  return state.robot_threads_ongoing
}

export const robotThreadsClosed = state => {
  return state.robot_threads_closed
}

export const visitorsUniapp = state => {
  return state.visitors_uniapp
}

export const visitorsFlutter = state => {
  return state.visitors_flutter
}

export const visitorsAndroid = state => {
  return state.visitors_android
}

export const visitorsIos = state => {
  return state.visitors_ios
}

export const visitorsWechat = state => {
  return state.visitors_wechat
}

export const workGroups = state => {
  return state.user.workGroups
}

// export const filterWorkGroups = state => {
//   return state.filter.workGroups
// }

export const filterWorkGroupMembers = state => {
  return state.filter.workGroupMembers
}

export const companies = state => {
  return state.companies
}

export const regions = state => {
  let regions = []
  for (let i = 0; i < state.regions.provinces.length; i++) {
    const province = state.regions.provinces[i]
    regions.push({ 'value': province.name, 'object': province })
  }
  for (let i = 0; i < state.regions.cities.length; i++) {
    const city = state.regions.cities[i]
    regions.push({ 'value': city.parent.name + city.name, 'object': city })
  }
  return regions
}

export const provinceCities = state => {
  let provinceCities = []
  for (let i = 0; i < state.regions.cities.length; i++) {
    const city = state.regions.cities[i]
    let contains = false
    for (let i = 0; i < provinceCities.length; i++) {
      const provinceCity = provinceCities[i]
      if (city.parent.code === provinceCity.value) {
        provinceCities[i].children.push({ value: city.code, label: city.name })
        contains = true
      }
    }
    if (!contains) {
      provinceCities.push({ value: city.parent.code, label: city.parent.name, children: [{ value: city.code, label: city.name }] })
    }
  }
  return provinceCities
}

export const allCuws = state => {
  return state.cuws
}

export const companyCuwCategories = state => {
  let categories = state.categories.filter(category => {
    return category.type === constants.CATEGORY_TYPE_CUW_COMPANY
  })
  categories.unshift({ 'id': 0, 'name': '全部分组', cuwChildren: [], 'type': constants.CATEGORY_TYPE_CUW_COMPANY })
  return categories
}

export const currentCompanyCuwCategoryId = state => {
  return state.current_company_cuw_category_id
}

export const companyCuws = state => {
  let cuws = []
  if (state.current_company_cuw_category_id === 0) {
    for (let i = 0; i < state.cuws[1].cuwChildren.length; i++) {
      const category = state.cuws[1].cuwChildren[i]
      for (let j = 0; j < category.cuwChildren.length; j++) {
        const cuw = category.cuwChildren[j]
        cuws.push(cuw)
      }
    }
  } else {
    for (let i = 0; i < state.cuws[1].cuwChildren.length; i++) {
      const category = state.cuws[1].cuwChildren[i]
      if (category.id === state.current_company_cuw_category_id) {
        for (let j = 0; j < category.cuwChildren.length; j++) {
          const cuw = category.cuwChildren[j]
          cuws.push(cuw)
        }
      }
    }
  }
  return cuws
}

export const fingerPrints = state => {
  return state.user.fingerPrints
}

export const userTags = state => {
  return state.user.userTags
}

export const threadTags = state => {
  return state.user.threadTags
}

export const robotCategories = state => {
  let categories = state.categories.filter(category => {
    return category.type === constants.CATEGORY_TYPE_ROBOT
  })
  categories.unshift({ 'id': 0, 'name': '全部类别', 'type': constants.CATEGORY_TYPE_ROBOT })
  return categories
}

export const robotAnswers = state => {
  return state.robot.answers
}

export const robotSynonyms = state => {
  return state.robot.synonyms
}

export const taboos = state => {
  return state.taboos
}

export const supportCategories = state => {
  let categories = state.categories.filter(category => {
    return category.type === constants.CATEGORY_TYPE_SUPPORT
  })
  categories.unshift({ 'id': 0, 'name': '全部分类', 'type': constants.CATEGORY_TYPE_SUPPORT })
  return categories
}

export const supportArticles = state => {
  return state.support.articles
}

export const supportComments = state => {
  return state.support.comments
}

/**
 * 暂时不显示质检角色，只显示：超级管理员、客服组长、客服人员、智能客服
 */
export const roles = state => {
  let roles = state.roles.filter(role => {
    return role.value !== constants.ROLE_WORKGROUP_CHECKER
  })
  return roles
}

export const webs = state => {
  return state.webs
}

export const apps = state => {
  return state.apps
}

export const mps = state => {
  return state.mps
}

export const minis = state => {
  return state.minis
}

export const settings = state => {
  return state.user.settings
}

// mqtt长连接状态
export const connectionStatus = state => {
  return state.user.settings.connection_status
}

// 网络状态
export const networkStatus = state => {
  return state.network_connection_status
}

// 网络是否正常
export const networkConnected = state => {
  return state.network_connection_status === constants.NETWORK_CONNECTION_STATUS_CONNECTED
}

// 是否正在拉取未读消息
export const isPullingUnreadMessage = state => {
  return state.is_pulling_unread_message
}

export const showAuthority = state => {
  return state.user.show_authority
}

export const mainHost = state => {
  return document.domain.split('.').slice(-2).join('.') + (location.port === '8081' ? ':8081' : '')
}

// 过滤掉自己 和 机器人
export const contacts = state => {
  return state.user.contacts.filter(contact => {
    return contact.uid !== state.user.info.uid && !contact.robot
  })
}

export const currentThreadUrl = state => {
  return state.user.current_thread_url
}

export const layimMine = state => {
  return {
    id: state.user.info.uid,
    username: state.user.info.realName,
    status: 'online',
    sign: state.user.info.description,
    avatar: state.user.info.avatar
  }
}

// export const layimFriends = state => {
//   let friends = []
//   for (let i = state.user.contacts.length - 1; i >= 0; i--) {
//     const agent = state.user.contacts[i]
//     // 一个人可以属于多个组
//     for (let j = 0; j < agent.workGroups.length; j++) {
//       const workGroup = agent.workGroups[j]
//       let contains = false
//       for (let k = 0; k < friends.length; k++) {
//         const friend = friends[k]
//         // 非当前用户 且 非智能机器人
//         if (friend.id === workGroup.wid && agent.uid !== state.user.info.uid && !agent.robot) {
//           friends[k].list.push({
//             id: agent.uid,
//             username: agent.realName,
//             sign: agent.description,
//             avatar: agent.avatar,
//             status: 'offline'
//           })
//           contains = true
//         }
//       }
//       // 非当前用户 且 非智能机器人
//       if (!contains && agent.uid !== state.user.info.uid && !agent.robot) {
//         friends.push({
//           id: workGroup.wid,
//           groupname: workGroup.nickname,
//           online: 0,
//           list: [{
//             id: agent.uid,
//             username: agent.realName,
//             sign: agent.description,
//             avatar: agent.avatar,
//             status: 'offline'
//           }]
//         })
//       }
//     }
//   }
//   return friends
// }

export const layimFriends = state => {
  let friends = [{
    id: '1',
    groupname: '同事',
    list: []
  }, {
    id: '2',
    groupname: '陌生人',
    list: []
  }]
  for (let i = 0; i < state.user.contacts.length; i++) {
    const friend = state.user.contacts[i]
    friends[0].list.push({
      id: friend.uid,
      username: friend.realName,
      sign: friend.description,
      avatar: friend.avatar,
      status: 'offline'
    })
  }
  return friends
}

export const layimGroups = state => {
  let groups = []
  for (let i = 0; i < state.user.groups.length; i++) {
    const group = state.user.groups[i]
    groups.push({
      id: group.gid,
      groupname: group.nickname,
      sign: group.description,
      avatar: group.avatar
    })
  }
  return groups
}
